import React from "react";
import { AssistantMode } from "../__generated__/AssistantMutation.graphql";
import CheckIcon from "@mui/icons-material/Check";
import { ElementType } from "react";

export enum SuggestionBehavior {
  opensMoreSuggestions = "opensMoreSuggestions", // to be implemented when needed
  goesToInput = "goesToInput",
  sendsMessage = "sendsMessage",
  closesAssistant = "closesAssistant"
}

export type SuggestionDefinition = {
  behavior?: SuggestionBehavior;
  text: string;
  icon?: ElementType;
  switchToMode?: AssistantMode;
  childSuggestions?: SuggestionDefinition[]; // to be implemented when needed
};

type SuggestionsDefinition = Partial<Record<AssistantMode, SuggestionDefinition[]>>;

export type TranslatedSuggestion = SuggestionDefinition & {
  nativeText: string;
  targetText: string;
};

const assistantSuggestions: SuggestionDefinition[] = [
  {
    behavior: SuggestionBehavior.goesToInput,
    text: "Give me examples of usage for:"
  },
  {
    behavior: SuggestionBehavior.goesToInput,
    text: "What is the difference between:"
  },
  {
    behavior: SuggestionBehavior.goesToInput,
    text: "What are synonyms for:"
  },
  {
    behavior: SuggestionBehavior.goesToInput,
    text: "What is the meaning of:"
  },
  {
    behavior: SuggestionBehavior.goesToInput,
    text: "How do I say:"
  },
  {
    behavior: SuggestionBehavior.goesToInput,
    text: "How is used the word:"
  },
  {
    behavior: SuggestionBehavior.goesToInput,
    text: "Explain me:"
  }
];

export const suggestionsDefinition: SuggestionsDefinition = {
  assistant: assistantSuggestions,
  aiStory: [
    {
      behavior: SuggestionBehavior.closesAssistant,
      text: "Thank you! That's all",
      icon: CheckIcon
    },
    {
      behavior: SuggestionBehavior.sendsMessage,
      text: "Make a fairytale"
    },
    {
      behavior: SuggestionBehavior.sendsMessage,
      text: "Make a romance story"
    },
    {
      behavior: SuggestionBehavior.sendsMessage,
      text: "Make a science-fiction story"
    },
    {
      behavior: SuggestionBehavior.sendsMessage,
      text: "Make a comedy story"
    }
  ],
  cardDetail: [
    {
      behavior: SuggestionBehavior.sendsMessage,
      text: "Suggest me synonyms"
    },
    {
      behavior: SuggestionBehavior.sendsMessage,
      text: "Write down examples of usage"
    },
    {
      behavior: SuggestionBehavior.sendsMessage,
      text: "Explain meaning"
    },
    {
      behavior: SuggestionBehavior.sendsMessage,
      text: "What is the word's origin"
    },
    {
      behavior: SuggestionBehavior.sendsMessage,
      text: "Teach me something about it"
    }
  ]
};

export function useFlattenSuggestions(): SuggestionDefinition[] {
  return React.useMemo(() => {
    let flattenedSuggestions: SuggestionDefinition[] = [];

    for (let key in suggestionsDefinition) {
      flattenedSuggestions = flattenedSuggestions.concat(suggestionsDefinition[key]);
    }

    return flattenedSuggestions;
  }, []);
}
